import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUser, clearToken } from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = getUser();
    return u || { name: 'User', initials: 'U', email: '', role: 'User', dept: '' };
  });

  useEffect(() => {
    const u = getUser();
    if (u) {
      setUser({
        id: u.id,
        name: u.name,
        initials: u.name?.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2) || 'U',
        email: u.email,
        role: u.role,
        dept: u.dept || '',
      });
    }
  }, []);

  const refreshUser = () => {
    const u = getUser();
    if (u) setUser({
      id: u.id,
      name: u.name,
      initials: u.name?.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2) || 'U',
      email: u.email,
      role: u.role,
      dept: u.dept || '',
    });
  };

  const logout = () => { clearToken(); window.location.href = '/login'; };

  return (
    <AuthContext.Provider value={{ user, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
